export default __webpack_public_path__ + "static/media/hospital-icon-side-bar-right.867ef4d0.svg";